import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import { getMainDefinition } from "@apollo/client/utilities"

import {
  getCurrentStatus,
  getUserToken,
  getDeviceToken,
  subscribeToStatus,
} from "./auth"

const tenant = process.env.REACT_APP_TENANT === "irishlife" ? "IL" : "WS"

const uri = process.env.REACT_APP_API_BASE_URL || "https://api.i18t.net"

/**
 * Apollo Link that blocks mutation operations when the user is not authenticated.
 * This is a defense-in-depth measure — the server must also enforce authentication.
 */
const authGuardLink = new ApolloLink((operation, forward) => {
  const definition = getMainDefinition(operation.query)
  // if (
  //   definition.kind === "OperationDefinition" &&
  //   definition.operation === "mutation"
  // ) {
  //   const status = getCurrentStatus()
  //   if (status !== "Authenticated") {
  //     throw new Error(
  //       "Authentication required. Please sign in before performing this action."
  //     )
  //   }
  // }
  return forward(operation)
})

const authLink = setContext(async (_, { headers }) => {
  const token = getUserToken()
  const deviceToken = getDeviceToken()

  let ourHeaders = { ...headers }
  if (token) {
    ourHeaders = { ...ourHeaders, Authorization: `Bearer ${token}` }
  }
  if (deviceToken) {
    ourHeaders = { ...ourHeaders, "X-Trusted-Device": deviceToken }
  }

  ourHeaders = {
    ...ourHeaders,
    "X-Tenant": tenant,
    "X-Application": `${tenant}-admin`,
  }

  return {
    headers: ourHeaders,
  }
})

const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    authGuardLink,
    authLink,
    createHttpLink({
      uri: `${uri}/graphql`,
      credentials: "include",
      fetchOptions: { cache: "no-store" },
    }),
  ]),
  cache: new InMemoryCache(),
})

// Clear store on logout
subscribeToStatus((status) => {
  if (status === "Anonymous") {
    apolloClient.clearStore()
  }
})

export default apolloClient
